// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Group } from "../../../data/app-core/group";
import { GroupPerson } from "../../../data/app-core/group-person";
import { OrganizationalUnitGroup } from "../../../data/app-core/organizational-unit-group";
import { EnvelopeDocument } from "../base/envelope-document";

export class GroupDocument extends EnvelopeDocument {
	public override Item: Group = new Group();
	public Persons: GroupPerson[] = [];
	public OrganizationalUnits: OrganizationalUnitGroup[] = [];
}